export default __webpack_public_path__ + "static/media/playlist-builder-skeleton.51a5c00c.svg";